import { relevanceMapping } from '../../../../../../../../../helpers/filterNames';
import { DocFact } from '@/api/types/backend-dto-types';
import { Chip } from '@/new/components/chip';
import { Checkbox } from '@/new/components/shadcn/checkbox';
import { CHIP_COLOURS } from '@/new/lib/chip-colours';
import { cn } from '@/new/lib/utils';

interface DocFactPickerFactProps {
  fact: DocFact;
  isSelected: boolean;
  onToggle: () => void;
  onNavigate: () => void;
  id?: string;
}

export function DocFactPickerFact({ fact, isSelected, onToggle, onNavigate, id }: DocFactPickerFactProps) {
  return (
    <button id={id} onClick={onNavigate} className="group relative w-full rounded-lg text-left shadow-lg/2">
      <div
        className={cn(
          'relative z-10 rounded-lg border bg-white p-3 px-4 pt-2.5 duration-200',
          isSelected ? 'border-blue-500 group-hover:border-blue-300' : 'border-gray-200 group-hover:border-blue-500',
        )}
      >
        <div className="mb-1 flex items-center justify-between gap-2">
          <div className="flex items-center gap-2">
            <Checkbox
              checked={isSelected}
              onCheckedChange={() => onToggle()}
              onClick={(e) => e.stopPropagation()}
              className="bg-white"
            />
            <p className="font-semibold">
              {fact.factDateText && fact.factDateText.charAt(0).toUpperCase() + fact.factDateText.slice(1)}
            </p>
          </div>
          {fact.relevance && (
            <Chip className={cn(CHIP_COLOURS.relevance[fact.relevance], '-mr-1.5 border py-0.5 text-[11px]')}>
              {relevanceMapping[fact.relevance]}
            </Chip>
          )}
        </div>

        <p>{fact.description}</p>
      </div>
    </button>
  );
}
